import { render, staticRenderFns } from "./HelpDashboard.vue?vue&type=template&id=5fd090cc&scoped=true&"
import script from "./HelpDashboard.vue?vue&type=script&lang=js&"
export * from "./HelpDashboard.vue?vue&type=script&lang=js&"
import style0 from "./HelpDashboard.vue?vue&type=style&index=0&id=5fd090cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd090cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
